
import { getPayments } from "@/api/payout";
import PaymentsTable from "@/components/affiliate/payments/PaymentsTable.vue";
import TablePageWrapper from "@/components/layout/TablePageWrapper.vue";
import { PaymentsColumns, PaymentsFilters } from "@/services/TablePage/payments";
import { downloadExcelFile, showServerError } from "@/utils";
import { Component, Vue } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { IColumnFilter } from "../../../types";
const auth = namespace('authModule');

@Component({
    components: { TablePageWrapper },
})

export default class Payments extends Vue {
    @auth.Getter('GET_USER') user;
    @Getter('GET_FILTERS_PARAMS_OBJECT') getFiltersParamsObject;

    columns: IColumnFilter[] = [];
    filters: PaymentsFilters = new PaymentsFilters();

    createPaymentForm = {
        route: { name: 'create-payment' },
    };

    table = {
        component: PaymentsTable,
        apiMethod: getPayments,
    };

    downloadOptions = {
        loading: false,
    };

    async getExcel(): Promise<void> {
        this.downloadOptions.loading = true;
        const params = this.getFiltersParamsObject;
        try {
            const file = await getPayments(params, 'xlsx');
            downloadExcelFile(file, 'Досрочки', 'xlsx');
        } catch (err) {
            showServerError(err, 'Файл не загружен');
        }
        this.downloadOptions.loading = false;
    }

    created(): void {
        const isDetail = this.$route.name === 'affiliate';
        if (isDetail) {
            this.columns = new PaymentsColumns().getColumnsForAffiliateDetailPage;
        } else {
            this.columns = new PaymentsColumns().getColumns();
        }
    }

    async mounted(): Promise<void>{
        await this.filters.getEmployeeMethods();
    }
}

